(function () {
  function swapImage(variantId) {
    const product = window.ulsc?.productJSON;
    if (!product) return;

    const variant = product.variants.find(v => v.id === parseInt(variantId));
    if (!variant || !variant.featured_image) return;

    const imgSrc = variant.featured_image.src;
    const slides = document.querySelectorAll('.slide--product img');
    if (slides.length > 0) {
      slides[0].src = imgSrc;
      slides[0].srcset = '';
      console.log('[VS] Imagen cambiada a:', imgSrc);
    }
  }

  let lastVariantId = new URLSearchParams(window.location.search).get('variant');

  setInterval(function () {
    const currentVariantId = new URLSearchParams(window.location.search).get('variant');
    if (currentVariantId && currentVariantId !== lastVariantId) {
      lastVariantId = currentVariantId;
      swapImage(currentVariantId);
    }
  }, 200);

})();
